export default __webpack_public_path__ + "static/media/2b-herringbone-90.5ce368c3.jpg";